module.exports = __webpack_public_path__ + "static/media/CircularStd-BookItalic.cc06409e.woff";